/**
 * Client-side REST refresh intervals (no SSE/WebSocket).
 * Vitals: charts do not need real-time updates.
 * Assigned device: assignment is rare; connection status benefits from fresher polls.
 */

/** ~30 minutes */
export const VITALS_REST_REFRESH_INTERVAL_MS = 30 * 60 * 1000;

/** 5 minutes — frequent enough to catch offline/online transitions mid-session */
export const ASSIGNED_DEVICE_REFRESH_INTERVAL_MS = 5 * 60 * 1000;
